<template>
  <v-switch v-bind="$attrs" v-on="$listeners" :ripple="!isLegacyAndroid" :class="[{'android-legacy-switch-fix': isLegacyAndroid}]"/>
</template>

<script>


export default {
  inheritAttrs: false,


}
</script>

<style>

</style>